import Axios from "axios";

export default function AllotmentCategoryList(){
    
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'viewCategoryList',                    
        }
    });
    return response;
}